var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trash-bin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.98,
    height: 19.079,
    viewBox: "0 0 15.98 19.079",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_246_",
    d: "M19.617,4.726H16.4V4.044A2.047,2.047,0,0,0,14.353,2H11.627A2.047,2.047,0,0,0,9.583,4.044v.681H6.363A1.364,1.364,0,0,0,5,6.088V6.77a.682.682,0,0,0,.681.681H20.3a.682.682,0,0,0,.681-.681V6.088A1.364,1.364,0,0,0,19.617,4.726Zm-8.671-.681a.683.683,0,0,1,.681-.681h2.726a.683.683,0,0,1,.681.681v.681H10.946Z",
    transform: "translate(-5 -2)",
    fill: "#ff0b0b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_249_",
    d: "M6,12V22.221a2.047,2.047,0,0,0,2.044,2.044h9.539a2.047,2.047,0,0,0,2.044-2.044V12Zm9.34,7.014a.681.681,0,0,1-.963.963l-1.562-1.562-1.562,1.562a.681.681,0,0,1-.963-.963l1.562-1.562-1.562-1.562a.681.681,0,0,1,.963-.963l1.562,1.562,1.562-1.562a.681.681,0,0,1,.963.963l-1.562,1.562Z",
    transform: "translate(-4.824 -5.186)",
    fill: "#ff0b0b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBin);
export default __webpack_public_path__ + "static/media/trash-bin.798fa25679cb2fb0e4aa3fa7b1d49deb.svg";
export { ForwardRef as ReactComponent };